






























import Vue from 'vue'
import { store as storeItems, Store as StoreType } from '../store'
import { SearchFacets } from '@/search/types'
import { CurrentCategory } from '@/model/category'
import FilterModal from '@/categories/components/FilterModal.vue'
import { MaxQuantityPrice } from '@/common/types/maxQuantityPrice'


export default Vue.extend({
  components: {
    FilterModal
  },
  props: {
    categoryId: {
      type: String,
      required: true
    },
    maxQuantityPrice: {
      type: Object as () => MaxQuantityPrice,
      required: true
    }
  },
  data() {
     return {
      paramModalVisible: false
     }
  },
  computed: {
    store(): StoreType {
      return storeItems
    },
    currentCategory(): CurrentCategory {
      const rootCategory = this.store.state.sidebar.rootCategory
      return {
        id: rootCategory.id,
        name: rootCategory.display_name
      }
    },
    categoryFacetData(): SearchFacets[]{
      return this.store.state.facetData
    }
  },
  created() {
    this.store.getSidebarData()
    const categoryId = this.currentCategory.id
    if (categoryId) this.store.fetchCategoryFacet(categoryId as number)
  },
  methods: {
    activeParamModal() {
      this.paramModalVisible = true
    },
    closeParamModal() {
      this.paramModalVisible = false
    }
  }
})
